import React from 'react';
import { motion } from 'framer-motion';
import '../../styles/hero/hero.scss';
import { useMediaQuery } from 'react-responsive'

import bgImageDesktop from '../../assets/hero/Tesla202.webp'
import bgImageMobile from '../../assets/hero/heroSmall.webp'

const Hero = () => {

    const isDesktopOrTablet = useMediaQuery({ query: '(min-width: 661px)' })
    const isMobile = useMediaQuery({ query: '(max-width: 660px)' })

    return(
        <div>
            {isDesktopOrTablet &&
                <div id='hero-body' style={{backgroundImage: `url(${bgImageDesktop})`}}>
                    <section id='left-hero'>
                        <section id='title-block'>
                            <h1 id='hero-text'>Find your home away from home</h1>
                            <motion.a
                                id="title"
                                activeClass="active"
                                offset={-115}
                                spy={true}
                                smooth={true}
                                duration={500}
                                target="_blank"
                                rel="noopener noreferrer"
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.9 }}
                                whileInView={{ opacity: 1 }}
                                href="https://docs.google.com/forms/d/e/1FAIpQLSd7moqxKKxk7mP0K_rex3Giv5ngFi4f8qQ8rf81urZ-wY1U3A/viewform?usp=sf_link">
                                <button id='rental-button'>
                                    Get matched with an intern house
                                </button>
                            </motion.a>
                        </section>
                    </section>
                </div>
            }
            {isMobile && 
                <div id='hero-body' style={{backgroundImage: `url(${bgImageMobile})`}}>
                <section id='left-hero'>
                    <section id='title-block'>
                        <h1 id='hero-text'>Find your home away from home</h1>
                        <motion.a
                            id="title"
                            role='link'
                            activeClass="active"
                            offset={-45}
                            spy={true}
                            smooth={true}
                            duration={500}
                            target="_blank"
                            rel="noopener noreferrer"
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                            whileInView={{ opacity: 1 }}
                            href="https://docs.google.com/forms/d/e/1FAIpQLSd7moqxKKxk7mP0K_rex3Giv5ngFi4f8qQ8rf81urZ-wY1U3A/viewform?usp=sf_link">
                            <button id='rental-button'>
                                Get matched with an intern house
                            </button>
                        </motion.a >
                    </section>
                </section>
            </div>
            }
        </div>
        
    );
}


export default Hero;